import React from "react";
import styled from "styled-components/macro";
import PropTypes from "prop-types";
import { ReactComponent as IconAdd } from "./icon-add.svg";
import { ReactComponent as IconRemove } from "./icon-remove.svg";

const AccordionContainer = styled.div`
  border: 2px solid ${p => p.theme.colors.gray};
  border-radius: 8px;
  margin-bottom: 8px;
  width: 100%;
`;

const AccordionHeader = styled.div`
  padding: 8px 16px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
`;

const AccordionContent = styled.div`
  padding: 0 16px;
  max-height: ${({ $isOpen }) => ($isOpen ? "500px" : "0")};
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
  font-size: ${props => props.theme.fontSizes[1]}px;
  p {
    margin: 4px 0;
  }
  p:first-child {
    margin-top: 0;
  }
  ul {
    margin: 4px 0;
    padding-left: 24px;
  }
  li {
    margin: 2px 0;
    padding-left: 4px;
  }
`;

const TimeInfo = styled.span`
  font-weight: normal;
  color: ${p => p.theme.colors.lightGray};
  font-size: 16px;
`;

const ToggleIcon = styled.span`
  font-size: 16px;
`;

export const Accordion = ({
  id,
  title,
  timeRange,
  isOpen,
  onClick,
  content,
}) => (
  <AccordionContainer>
    <AccordionHeader
      onClick={() => onClick(id)}
      aria-expanded={isOpen}
      $isOpen={isOpen}
    >
      <div>
        {title} <TimeInfo>({timeRange})</TimeInfo>
      </div>
      <ToggleIcon>{isOpen ? <IconRemove /> : <IconAdd />}</ToggleIcon>
    </AccordionHeader>
    <AccordionContent $isOpen={isOpen}>
      {isOpen && <div>{content}</div>}
    </AccordionContent>
  </AccordionContainer>
);

Accordion.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  timeRange: PropTypes.string,
  content: PropTypes.node,
  isOpen: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

Accordion.defaultProps = {
  id: "",
  title: "",
  timeRange: "",
  content: null,
  isOpen: false,
};
